import {
  type RouteRecordRaw,
} from 'vue-router'
import DefaultLayout from '@/layout/default/index.vue'
import { findFirstRouteWithPermission } from '../utils'

const StatementRoutes: RouteRecordRaw[] = [
  {
    name: 'Statement',
    path: '/statement',
    redirect: () => {
      return findFirstRouteWithPermission(StatementRoutes[0].children ?? [])
    },
    meta: {
      title: '对账中心',
      order: 2,
    },
    component: DefaultLayout,
    children: [{
      path: 'index',
      name: 'StatementIndex',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '对账总览',
        devUrl: 'http://localhost:8001/statement/index',
        url: `${window.location.origin}/merchant-platform/micro-trade/statement/index`,
        isTopLevel: true,
        icon: 'icon-zonglan',
        permission: ['BILL_UNION'],
      },
    }, {
      path: 'transaction',
      name: 'Transaction',
      meta: {
        title: '交易管理',
        icon: 'icon-document-text',
      },
      redirect: { name: 'TransactionOrder' },
      children: [{
        path: 'order',
        name: 'TransactionOrder',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '交易订单查询',
          devUrl: 'http://localhost:8001/trade-query',
          url: `${window.location.origin}/merchant-platform/micro-trade/trade-query`,
          permission: ['ORDER_QUERY'],
        },
      },
      {
        path: 'transfer',
        name: 'TransactionTransfer',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '线下转账充值查询',
          devUrl: 'http://localhost:8001/trade-query/offline-transfer',
          url: `${window.location.origin}/merchant-platform/micro-trade/trade-query/offline-transfer`,
          permission: ['OFFINE_DEPOSIT_RECORD_QUERY'],
        },
      }],
    }, {
      path: 'bill',
      name: 'StatementBill',
      meta: {
        title: '账单管理',
        icon: 'icon-zhangdanguanli',
      },
      redirect: { name: 'BillTrade' },
      children: [
        {
          path: 'trade',
          name: 'BillTrade',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '交易账单',
            devUrl: 'http://localhost:8001/bill/trade',
            url: `${window.location.origin}/merchant-platform/micro-trade/bill/trade`,
            permission: ['BILL_TRANSACTION'],
          },
        },
        {
          path: 'group-trade',
          name: 'GroupBillTrade',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '总部商户交易账单',
            devUrl: 'http://localhost:8007/group-bill/trade',
            url: `${window.location.origin}/merchant-platform/micro-group/group-bill/trade`,
            permission: ['OFFICE_TRADE_BILL_QUERY'],
          },
        },
        {
          path: 'fund',
          name: 'BillFund',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '资金账单',
            devUrl: 'http://localhost:8001/bill/capitalbill',
            url: `${window.location.origin}/merchant-platform/micro-trade/bill/capitalbill`,
            permission: ['BILL_FUNDS'],
          },
        },
        {
          path: 'separateAccounts',
          name: 'SeparateAccounts',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '分账账单',
            devUrl: 'http://localhost:8001/statement/subbill',
            url: `${window.location.origin}/merchant-platform/micro-trade/statement/subbill`,
            permission: ['BILL_SHARING'],
          },
        },
        {
          path: 'payment',
          name: 'BillPayment',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '付款账单',
            devUrl: 'http://localhost:8001/statement/paybill',
            url: `${window.location.origin}/merchant-platform/micro-trade/statement/paybill`,
            permission: ['BILL_TRANSFER'],
          },
        },
        {
          path: 'salarySpecialAccount',
          name: 'SalarySpecialAccount',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '发薪专户资金明细',
            devUrl: 'http://localhost:8001/bill/flexible',
            url: `${window.location.origin}/merchant-platform/micro-trade/bill/flexible`,
            permission: ['TAX_BILL_QUERY'],
          },
        },
      ],
    },
    {
      path: 'capitalFlow',
      name: 'StatementCapitalFlow',
      meta: {
        title: '资金流水',
        icon: 'icon-currency-yen',
      },
      children: [{
        path: 'accountDetails',
        name: 'CapitalFlowAccountDetails',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '账户明细',
          devUrl: 'http://localhost:8001/statement/detaillog',
          url: `${window.location.origin}/merchant-platform/micro-trade/statement/detaillog`,
          permission: ['BILL_DETAIL'],
        },
      },
      {
        path: 'splitReceiptDetail',
        name: 'SplitReceiptDetail',
        component: () => import('@/views/wujie.vue'),
        meta: {
          title: '分账收款明细',
          devUrl: 'http://localhost:8001/statement/splitReceiptDetail',
          url: `${window.location.origin}/merchant-platform/micro-trade/statement/splitReceiptDetail`,
          permission: ['BILL_SHARING'],
        },
      },
      ],
    },
    {
      path: 'financial-vouchers',
      name: 'FinancialVouchers',
      meta: {
        title: '财务凭证',
        icon: 'icon-jinrong',
      },
      children: [
        {
          path: 'voucher-apply',
          name: 'VoucherApply',
          component: () => import('@/views/wujie.vue'),
          meta: {
            title: '凭证申请',
            devUrl: 'http://localhost:8001/voucher-apply/index',
            url: `${window.location.origin}/merchant-platform/micro-trade/voucher-apply/index`,
            permission: ['FINANCIAL_VOUCHER_DOWNLOAD'],
          },
        },
      ],
    },
    ],
  },
]
export default StatementRoutes
